// toast behaviour — reveal / auto-dismiss the pre-built toast node.
//
// messages.js builds + appends the toast DOM (template, icon, content, close
// button); this adapter only animates it in/out and wires the close button — a
// zero-dependency adapter that fits the toast.show(el) contract exactly. (base
// bridgeTierAttrs is a no-op in cleanSlate, so the close button is wired here.)

// Auto-dismiss delay (ms) for a shown toast.
const TOAST_TIMEOUT = 5000;
// Fallback removal delay (ms) if the CSS transitionend never fires (reduced
// motion, a display:none ancestor, etc.) so a toast node can't leak.
const TOAST_TRANSITION_FALLBACK = 400;

// Remove a toast: slide/fade out, then drop the node. Idempotent — guarded so
// a manual close + the auto-dismiss timer can't double-run.
function dismissToast(el) {
    if (el.zitToastDismissed) {
        return;
    }
    el.zitToastDismissed = true;

    if (el.zitToastTimer) {
        clearTimeout(el.zitToastTimer);
    }

    el.classList.remove('zit-cs-toast-visible');
    el.classList.add('zit-cs-toast-hiding');

    const remove = () => {
        el.remove();
    };

    // Prefer the transition end; fall back to a timer so a missed event
    // can't leave the node behind.
    el.addEventListener('transitionend', remove, { once: true });
    setTimeout(remove, TOAST_TRANSITION_FALLBACK);
}

const toast = {
    show: function (el) {
        // Wire close button(s) — base bridgeTierAttrs is a no-op here.
        const closers = el.querySelectorAll('[data-zit-dismiss="toast"]');
        closers.forEach((btn) => {
            btn.addEventListener('click', () => dismissToast(el));
        });

        // Double rAF so the toast's initial (hidden) styles are committed
        // before flipping to visible, guaranteeing the enter transition runs.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                el.classList.add('zit-cs-toast-visible');
            });
        });

        // Auto-dismiss after the timeout.
        el.zitToastTimer = setTimeout(() => dismissToast(el), TOAST_TIMEOUT);
    }
};

export default toast;
